/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import axios from 'axios';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Image } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PropTypes, { bool } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPlus } from '@fortawesome/free-solid-svg-icons';
import { TableContext } from '../../contexts/tableContext';
import ActionButtons from '../ActionsButtons/ActionButtons';
import { tabledelete } from '../../redux/TableDeleteSlice';
import ToggleButtonOnOff from '../ToggleButton/ToggleButton';
import styles from './VendorCustomTable.module.scss';
import { getCookies } from '../../hooks/useCookies';
import searchImg from '../../assets/search.svg';
import Paginations from '../Pagination/Paginations';
import DeleteModal from '../DeleteModal/DeleteModal';
import EventActionButtons from '../ActionsButtons/EventActionButtons';
import PopUp from '../PopUp/popUp';
import ExportToExcel from '../Export/ExportToExcel';
import noresults from '../../assets/noresults.svg';

const VendorCustomTable = React.memo(
  ({ urlParam, viewPopUp, toggleButton, section, formatter, deleteCondition, dashTitle }) => {
    let url;
    const { dashboardStyle } = useContext(TableContext);
    const navigate = useNavigate();
    const { bodyStyle } = useContext(TableContext);
    const [addButtonPermissions, setAddButtonPermissions] = useState({});
    const { bodyheader } = useContext(TableContext);
    const { setDashboardHeader } = useContext(TableContext);
    const { searchboxStyle } = useContext(TableContext);
    const { tableheadStyle } = useContext(TableContext);
    const { tablebodyStyle } = useContext(TableContext);
    const [tableData, setTableData] = useState([]);
    const dispatch = useDispatch();
    const { pageNumView, setPageNumView } = useContext(TableContext); // for controlling view or edit backbutton
    const [pageNum, setPageNum] = useState(1);
    // new
    const tablelength = tableData.length;
    const [checkedState, setCheckedState] = useState(new Array(tablelength).fill(false));
    const [checkedAll, setCheckedAll] = useState(false);
    const token = `Bearer ${getCookies('Token')}`;
    const [sorting, setSorting] = useState([{ col: 'none', sortType: 'none' }]);
    const [paginationData, setPaginationData] = useState([
      { page: 0, totalResult: 0, totalPages: 0 },
    ]);
    const [search, setSearchTerm] = useState(null);
    const [timer, setTimer] = useState(null);
    const [columns, setColumns] = useState([]);
    const [tableConfig, setTableConfig] = useState();
    const [deletedData, setDeletedData] = useState(null);
    const [selected, setselected] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [deleteSuccess, setDeleteSuccess] = useState();
    const [showDeleteModal, setDeleteModal] = useState(false);
    const [showPopupModal, setPopupModal] = useState(false);
    const dataPerPage = 10;
    let response;
    let statusCode;

    const handleOnChange = (id, position) => {
      // eslint-disable-next-line max-len
      // eslint-disable-next-line max-len
      const updatedCheckedState = checkedState.map((item, indexed) =>
        indexed === position ? !item : item
      );
      setCheckedState(updatedCheckedState);
      setselected((oldArray) => [...oldArray, id]);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i <= checkedState.length; i++) {
        if (checkedState[position] === true) {
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < selected.length; j++) {
            if (selected[j] === id) {
              selected.splice(j, 1);
            }
            // const newselected = selected.filter((item) => item === id);
            // setselected(newselected);
          }
        }
      }
    };

    const actionAdd = () => {
      navigate(`/${section.toLowerCase()}/create/`);
    };

    const truncateText = (text, maxLength = 25) => {
      if (typeof text !== 'string') return text;
      return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    const handleOnChangeAll = () => {
      setCheckedAll(!checkedAll);
      const newarray = [];
      if (checkedAll === false) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          newarray.push(tableData[i].id);
          checkedState[i] = true;
        }
        setselected(newarray);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          checkedState[i] = false;
        }
        setselected([]);
      }
    };

    const getUsers = async () => {
      setTableLoading(true);
      url = urlParam;
      url += `page=${pageNumView > 1 ? pageNumView : pageNum}&limit=${dataPerPage}`;
      if (sorting.sortType && sorting.sortType !== 'none') {
        url += `&sortBy=${sorting.col}:${sorting.sortType}`;
      }
      if (search !== null) {
        url += `&searchBy=${search}`;
      }
      axios
        .get(url, {
          method: 'GET',
          headers: { Authorization: token },
        })
        .then((resp) => {
          setTableLoading(false);
          statusCode = resp.status;
          return resp;
        })
        .then((res) => {
          if (statusCode === 200) {
            response = res.data.data.result;
            setTableData(response.results);
            setPaginationData({
              page: response.page,
              totalResult: response.totalResults,
              totalPages: response.totalPages,
            });
            setPageNum(response.page);
            const { Displayfields } = response;
            if (Array.isArray(Displayfields)) {
              setColumns(Displayfields);
            } else {
              const colkeys = Object.keys(Displayfields);
              setTableConfig(Displayfields);
              setColumns(colkeys);
            }
          }
        })
        .catch((err) => {
          setTableLoading(false);
          return err;
        });
      if (pageNumView > 1) setPageNumView(1);
    };

    const confirmDelete = () => {
      const actionData = {};
      actionData.actionUrl = section.toLowerCase();
      actionData.apiData = selected;
      dispatch(tabledelete(actionData))
        .then(() => {
          toast.success('Rows deleted successfully.');
          setDeletedData(`data deleted ${selected}`);
          setDeleteModal(false);
        })
        .catch((e) => toast.error('Something went wrong!!'));
    };

    const handleDelete = () => setDeleteModal(true);
    const handleDeleteClose = () => setDeleteModal(false);

    const handlePopup = () => setPopupModal(true);
    const handlePopupClose = () => setPopupModal(false);

    useEffect(() => {
      setSearchTerm(null);
      setPageNum(1);
    }, []);

    useEffect(() => {
      if (dashTitle) setDashboardHeader(dashTitle);
      else setDashboardHeader(section);
      const temp = section.replace(/\s+/g, '').toLowerCase();
      const permissions = getCookies('USERPERMISSION');
      permissions.forEach((val) => {
        if (val.section.toLowerCase() === temp) {
          setAddButtonPermissions({
            view: val.view ? val.view : false,
            edit: val.edit ? val.edit : false,
            create: val.create ? val.create : false,
            delete: val.delete ? val.delete : false,
            list: !!(val.view || val.edit || val.create || val.delete),
          });
        } else if (val.submenu) {
          val.submenu.forEach((element) => {
            if (element.section.toLowerCase() === temp) {
              setAddButtonPermissions({
                view: element.view ? element.view : false,
                edit: element.edit ? element.edit : false,
                create: element.create ? element.create : false,
                delete: element.delete ? element.delete : false,
                list: !!(element.view || element.edit || element.create || element.delete),
              });
            }
          });
        }
      });
      getUsers();
      const newarray = [];
      if (checkedAll) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          newarray.push(tableData[i].id);
          checkedState[i] = true;
        }
        setselected(newarray);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          checkedState[i] = false;
        }
        setselected([]);
      }
    }, [pageNum, search, sorting, deletedData, deleteSuccess]); // add needed variables to refresh the page

    const setSort = (param) => () => {
      setPageNum(1);
      switch (sorting.sortType) {
        case 'none':
          setSorting({ col: param, sortType: 'asc' });
          break;
        case 'asc':
          setSorting({ col: param, sortType: 'desc' });
          break;
        case 'desc':
          setSorting({ col: param, sortType: 'none' });
          break;
        default:
          setSorting({ col: param, sortType: 'asc' });
          break;
      }
    };

    const onFilterTextChange = (e) => {
      const even = e;
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
      setTimer(
        setTimeout(() => {
          const { value } = even.target;
          if (value.length > 0) {
            setPageNum(1);
            setSearchTerm(even.target.value.trim());
          } else {
            setSearchTerm(null);
          }
        }, 1000)
      );
    };

    return (
      <div className={styles[bodyStyle]}>
        {/* DELETE MODAL */}
        <DeleteModal
          show={showDeleteModal}
          handleClose={handleDeleteClose}
          onConfirm={confirmDelete}
          onCancel={handleDeleteClose}
        />
        <PopUp
          show={showPopupModal}
          handleClose={handlePopupClose}
          onCancel={handlePopupClose}
          setData={setDeletedData}
        />

        {addButtonPermissions.list && (
          <div
            className={styles[dashboardStyle]}
            style={{ minHeight: '100vh' }}
            id={styles.dashboardcont2}
          >
            <div className="container-fluid" id={styles.container}>
              <div className="table_top">
                <div className="search_contain mb-20">
                  <Image src={searchImg} alt="search" />
                  <input
                    className={`${styles[searchboxStyle]} searchbar`}
                    type="search"
                    onChange={onFilterTextChange}
                    placeholder={
                      section === 'attendee'
                        ? 'Search by Name, Email or Phone'
                        : section === 'contest' || section === 'past-contest'
                        ? 'Search by Contest Name'
                        : section === 'manager'
                        ? 'Search by Event manager Name, Business Name, Email or Phone number'
                        : section === 'vendorusers'
                        ? 'Search by Vendor Name, Stall Name, Email or Phone number'
                        : section === 'audit'
                        ? 'Search by Name or Email'
                        : section === 'reported' || section === 'concluded'
                        ? 'Search by Title, Category, Reported By'
                        : 'Search'
                    }
                    // value={search}
                    readOnly={tableLoading}
                  />
                  <div
                    className={tableLoading ? 'spinner-border spinner-border-sm' : ''}
                    id={styles.spinner}
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
                <div className={styles.sectionright}>
                  {addButtonPermissions.delete && selected.length > 0 && (
                    <div className="dropdown" id={styles.dropdown}>
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Actions
                      </button>
                      <ul
                        className="dropdown-menu"
                        id={styles.dropdown_menu}
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a className="dropdown-item" onClick={handleDelete}>
                            Delete{' '}
                            <i className="fa fa-trash" aria-hidden="true" id={styles.del_icon} />
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                  {tableData.length !== 0 && (
                    <ExportToExcel apiUrl="eventdashboard/vendorreport" fileName="Vendor_List" />
                  )}
                  {addButtonPermissions.create && (
                    <button className="addBtn mb-20" type="button" onClick={handlePopup}>
                      {' '}
                      <FontAwesomeIcon icon={faPlus} className="add_icon" />
                      {section === 'vendor' ? 'Add Vendor' : 'Add New'}
                    </button>
                  )}
                </div>
              </div>
              <div className="table-responsive" style={{ minHeight: '250px' }}>
                <table className="table table-borderless">
                  {columns.length > 0 && (
                    <thead>
                      <tr className={styles[tableheadStyle]}>
                        {/* {addButtonPermissions.delete && (
                          <th scope="col">
                            <input
                              type="checkbox"
                              id="custom-checkbox"
                              // name={data.id}
                              // value={data.id}
                              checked={checkedAll}
                              onChange={() => handleOnChangeAll()}
                            />
                          </th>
                        )} */}
                        {/* Table Heading From the display feilds view data  */}
                        {columns.map((item) => (
                          <th scope="col">
                            {' '}
                            {tableConfig
                              ? tableConfig[item.db].alias.toUpperCase()
                              : item.view.toUpperCase()}
                            {tableConfig ? (
                              tableConfig[item.db].isSort && (
                                <button
                                  className={styles.sortbtn}
                                  type="button"
                                  aria-label="Sort button"
                                  onClick={setSort(item.db)}
                                >
                                  {sorting.sortType === 'asc' && sorting.col === item.db ? (
                                    <i className="fa fa-arrow-up" />
                                  ) : sorting.sortType === 'desc' && sorting.col === item.db ? (
                                    <i className="fa fa-arrow-down" />
                                  ) : (
                                    <i className="fa fa-sort" />
                                  )}
                                </button>
                              )
                            ) : (
                              <button
                                className={styles.sortbtn}
                                type="button"
                                aria-label="Sort button"
                                onClick={setSort(item.db)}
                              >
                                {sorting.sortType === 'asc' && sorting.col === item.db ? (
                                  <i className="fa fa-arrow-up" />
                                ) : sorting.sortType === 'desc' && sorting.col === item.db ? (
                                  <i className="fa fa-arrow-down" />
                                ) : (
                                  <i className="fa fa-sort" />
                                )}
                              </button>
                            )}
                          </th>
                        ))}
                        <th scope="col">ACTIONS</th>
                      </tr>
                    </thead>
                  )}
                  {/* Table Data mapping From the display feilds db data  as it where the db feild */}
                  {Object.keys(tableData) && !tableLoading ? (
                    <tbody>
                      {tableData.map((item, index) => (
                        <tr className={styles[tablebodyStyle]}>
                          {/* {addButtonPermissions.delete && (
                            <th scope="row">
                              <div className="left-section">
                                <input
                                  type="checkbox"
                                  id={`custom-checkbox-${item}`}
                                  name={item.id}
                                  value={item.id}
                                  checked={checkedState[index]}
                                  onChange={() => handleOnChange(item.id, index)}
                                />
                              </div>
                            </th>
                          )} */}
                          {columns.map((ele) => (
                            <td style={{ fontSize: '14px' }}>
                              {ele.db === toggleButton.field ? (
                                toggleButton.show ? (
                                  <ToggleButtonOnOff
                                    value={item[ele.db]}
                                    id={item.id}
                                    section={section}
                                    onSuccess={getUsers}
                                  />
                                ) : item[ele.db] ? (
                                  <p className={styles.tdactive}>Active</p>
                                ) : (
                                  <p className={styles.tdinactive}>Inactive</p>
                                )
                              ) : typeof item[ele.db] === 'boolean' ? (
                                <h6 className="order_date"> String(item[ele.db])</h6>
                              ) : formatter && Object.keys(formatter).includes(ele.db) ? (
                                formatter[ele.db](item[ele.db])
                              ) : ele.db === 'eventName' ? (
                                <b>{item[ele.db]}</b>
                              ) : ele.db === 'category' ? (
                                <p className={styles.tdyellowbg}>{item[ele.db]}</p>
                              ) : ele.db === 'email' ? (
                                truncateText(item[ele.db])
                              ) : (
                                item[ele.db]
                              )}
                            </td>
                          ))}
                          <td>
                            {section === 'vendor' ? (
                              <EventActionButtons
                                data={item}
                                viewPopUp={viewPopUp}
                                section={section}
                                pageNum={pageNum}
                                setDeleteSuccess={setDeleteSuccess}
                              />
                            ) : (
                              <ActionButtons
                                data={item}
                                viewPopUp={viewPopUp}
                                section={section}
                                pageNum={pageNum}
                                setDeleteSuccess={setDeleteSuccess}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td
                          className={styles.tableLoadingCell}
                          colSpan={columns.length + 1}
                          role="status"
                          aria-label="Loading"
                        >
                          <p className={styles.tableLoadingText}>Loading ..</p>
                        </td>
                      </tr>
                    </tbody>
                  )}
                  {tableData.length === 0 && !tableLoading ? (
                    <div className={styles.norecordsdiv}>
                      <Image src={noresults} alt="" />
                      <h6 className={styles.norecord}>No Items to Display</h6>
                    </div>
                  ) : (
                    ''
                  )}
                </table>
              </div>
            </div>
            {!tableLoading && tableData.length !== 0 && (
              <Paginations
                paginationData={paginationData}
                setPageNum={setPageNum}
                dataName="Vendor"
                // maxPagesToShow={5}
              />
            )}
          </div>
        )}
      </div>
    );
  }
);

VendorCustomTable.propTypes = {
  urlParam: PropTypes.string,
  viewPopUp: PropTypes.bool,
  toggleButton: PropTypes.oneOfType([PropTypes.object]),
  deleteCondition: PropTypes.oneOfType([PropTypes.object]),
  formatter: PropTypes.oneOfType([PropTypes.object]),
  section: PropTypes.string,
  dashTitle: PropTypes.string,
};

VendorCustomTable.defaultProps = {
  viewPopUp: false,
  toggleButton: { show: false, field: 'none' },
  deleteCondition: { checkCondition: false, apiUrl: 'none' },
  section: 'User',
  formatter: undefined,
  urlParam: null,
  dashTitle: undefined,
};

export default VendorCustomTable;
